import { SVGProps } from 'react';
import { WithId, WithDmId } from '../../utils/BaseProps';

export type ImageSize = string | number;

export type BaseLogoProps = WithId &
  WithDmId & {
    /**
     * Pointer Events
     */
    pointerEvents?: string;
    /**
     * Größe des Icons, z.B. 18
     * Der default-Wert ist 24
     */
    size?: ImageSize;
    /**
     * ViewBox des Icons
     */
    viewBox?: string;
  };

export type LogoProps = BaseLogoProps &
  Omit<Omit<SVGProps<SVGSVGElement>, keyof BaseLogoProps>, 'ref'>;

// as we don't want description and title to be configurable for logos, we have to split logoprops and logoSvgProps here
export type BaseLogoSvgProps = LogoProps & {
  /**
   * Beschreibung des Icons
   * (Accessibility)
   */
  description?: string;
  /**
   * Pointer Events
   */
  pointerEvents?: string;
  /**
   * Größe des Icons, z.B. 18
   * Der default-Wert ist 24
   */
  size?: ImageSize;
  /**
   * ViewBox des Icons
   */
  viewBox?: string;
  /**
   * Titel des Icons
   * (Accessibility)
   */
  title?: string;
};

export type LogoSvgProps = BaseLogoSvgProps &
  Omit<Omit<SVGProps<SVGSVGElement>, keyof BaseLogoSvgProps>, 'ref'>;

export type BaseIconProps = LogoSvgProps & {
  /**
   * Grundfarbe des Icons
   * (Hinweis: Farbwerte aus dem Theme verwenden!)
   */
  color?: string;
  /**
   * Zweitfarbe des Icons (je nach Icon)
   * (Hinweis: Farbwerte aus dem Theme verwenden!)
   */
  secondColor?: string;
};

export type IconProps = BaseIconProps &
  Omit<Omit<SVGProps<SVGSVGElement>, keyof BaseIconProps>, 'ref'>;

export const DEFAULT_IMAGE_SIZE = 24;
